import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT } from "../../config/data";

// Here we store only audio-related properties:
// e.g., volume, play/pause state, audio source URL, etc.
const initialState = {
    volume: DEFAULT.DEFAULT_SETTINGS.volume,
    playStatus: DEFAULT.DEFAULT_SETTINGS.playStatus,
    audioSrc: '',
    
};

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setVolume: (state, action) => {
            state.volume = action.payload;
        },
        setPlayStatus: (state, action) => {
            state.playStatus = action.payload;
        },
        setAudioSource: (state, action) => {
            state.audioSrc = action.payload;
        },
        setProcessorStatus: (state, action) => {
            state.processorStatus = action.payload;
        },
    },
});

export const { setVolume, setPlayStatus, setAudioSource, setProcessorStatus} = globalSlice.actions;
export default globalSlice.reducer;
